import { useDispatch } from 'react-redux';

import { Space, Typography } from 'antd';

import ImageRatio from '@/components/shared/ImageRatio';
import { getCdnUrl } from '@/helpers';
import { IInvite } from '@/interfaces/invite';
import { enNotificationOrigin } from '@/interfaces/notification';
import { setNotification } from '@/redux/notification/slice';
import styled, { css, StyledProp } from '@/styled';

import Actions from './Actions';

const Item = (props: IInvite & StyledProp) => {
  const dispatch = useDispatch();

  const handleAction = () => {
    dispatch(
      setNotification({
        origin: enNotificationOrigin.invite,
        course: {
          producer: { name: props.course.producer_name, avatar: props.course.producer_avatar },
          courseLink: props.course.link,
          title: props.course.title,
          cover: props.course.customization.new_card_background
        },
        hash: props.hash
      })
    );
  };

  return (
    <>
      <div className={props.className} onClick={handleAction}>
        <ImageRatio
          className='image'
          aspect='16:9'
          src={getCdnUrl(
            props?.course?.customization?.new_card_background,
            props?.course?.customization?.new_avatar,
            props?.course?.customization?.avatar
          )}
          alt='imagem da notificação'
        />
        <Space size={0} direction='vertical'>
          <Typography.Text className='title' ellipsis>
            {props?.course?.title}
          </Typography.Text>
          <Typography.Text className='title' ellipsis>
            Enviado por {props?.course.author.name}
          </Typography.Text>
          <Actions hash={props.hash} />
        </Space>
      </div>
    </>
  );
};

export default styled(Item)(({ theme }) => {
  return css`
    display: grid;
    align-self: center;
    justify-content: flex-start;
    width: 100%;
    padding: ${theme.space.spacing(3, 6)};
    grid-gap: ${theme.space.pxToRem(8)};
    grid-template-columns: 130px auto;
    border-bottom: 1px solid ${theme.variables.borderColor};

    button {
      padding: ${theme.space.spacing(0, 2)};
      height: 24px;
      border: 1px solid ${theme.variables.borderColor};
      background: ${theme.palette.alpha(theme.palette.gray[0], 0.02)};

      svg {
        margin-right: ${theme.space.pxToRem(4)};
      }
    }

    .title {
      max-width: 300px;
    }

    .content {
      max-width: 300px;
      overflow: hidden;
    }

    .accept {
      background: ${theme.palette.alpha(theme.palette.gray[0], 0.1)};
    }

    .ant-typography,
    .ant-space-item {
      height: 24px;
    }

    .courseTitle {
      color: ${theme.colorTextTertiary};
    }

    .sideContent {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-end;
    }
  `;
});
